let userInfor = localStorage.getItem('_userinfor') ? JSON.parse(localStorage.getItem('_userinfor')) : {};
const UserInforReducer =(state = userInfor, action ) => {
    if(action.type === "UPDATE_USER_INFOR"){
        return action.UserInfor 
    }
    return state
}
export default UserInforReducer
